module.exports = __webpack_public_path__ + "img/logo.9926bb86.png";